export const addLazyLoadingToImages = (html) => {
    return html.replace(/<img((?:(?!\sloading\s*=)[^>])*)>/g, '<img loading="lazy"$1>');
};
